import { render, staticRenderFns } from "./generalConfirm.vue?vue&type=template&id=363d93b4&scoped=true"
import script from "./generalConfirm.vue?vue&type=script&lang=js"
export * from "./generalConfirm.vue?vue&type=script&lang=js"
import style0 from "./generalConfirm.vue?vue&type=style&index=0&id=363d93b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363d93b4",
  null
  
)

export default component.exports